const CONSTANTS = {
    observerGap: window.innerWidth > 576 ? "-300px" : "-100px",
};

export default CONSTANTS